import { TemplateData, TemplateParams } from '.';

const achievementRequestMilestoneDenied = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementRequestMilestoneDeniedDescription}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementRequestMilestoneDenied}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Here is your achievement.'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementRequestMilestoneDenied
});

export default achievementRequestMilestoneDenied;
